import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule, PaginationModule, TabsModule } from 'ngx-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { ModalModule } from './shared/modules/modal/modal.module';
import { AuthModule } from './auth/auth.module';
import {
  EntryComponentsModule
} from './shared/modules/entry-components/entry-components.module';

import { EntitiesService, PlanningDataService, PlanningApiService, PlanningFormService } from './shared/services';
import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.component';
import { HomeComponent } from './home/home.component';

import { routingModule } from './app.routing';
import { AppConfig } from './shared/services/app-config';
import { LaunchDarklyService } from './shared/services/launch-darkly.service';

import { StartUpMenuComponent } from './start-up-menu/start-up-menu.component';
import { ChosenWorkspaceRedirectComponent } from './chosen-workspace-redirect/chosen-workspace-redirect.component';

import { V2Module } from './v2/module';

import { ToastrModule } from 'ngx-toastr';

import { NgIdleModule } from '@ng-idle/core';
import { IdleService } from './shared/services/idle.service';

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/legacy/assets/i18n/');
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.loadFromFile();
}

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    ChosenWorkspaceRedirectComponent,
    StartUpMenuComponent,
    HomeComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
    CoreModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule,
    routingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AuthModule,
    EntryComponentsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(), // This is required for translation service to work, why?
    V2Module,
    NgIdleModule.forRoot()
  ],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
    EntitiesService,
    PlanningDataService,
    PlanningApiService,
    PlanningFormService,
    IdleService,
    LaunchDarklyService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
